import { useMutation } from "@apollo/client/react";
import { SAVE_EXEMPTION } from "../../mutations/invoices/saveExemption";
import type {
  SaveWhitelistInput,
  SaveExemptionResult,
} from "../../../models/InvoiceAssessment";

// No refetch: an exemption only affects the result after a new assessment.
export const useSaveExemption = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: SaveExemptionResult) => void;
  onError: (e: Error) => void;
}) => {
  const [saveExemption, { data, loading, error }] = useMutation<
    SaveExemptionResult,
    { input: SaveWhitelistInput }
  >(SAVE_EXEMPTION, {
    onCompleted: onCompleted,
    onError: onError,
  });

  return { saveExemption, data, loading, error };
};
